import { CallAPI } from "../../apiManager/ApiCall";
import {
  addSlideFileURL,
  deleteSlideFileURL,
  pushURL,
} from "../../apiManager/APIConfig";

export const SendPush = async (body) => {
  try {
    const response = await CallAPI({ url: pushURL, method: "POST", body });
    console.log("pippo response");

    // GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
export const GetAllPush = async (file_id) => {
  try {
    const response = await CallAPI({
      url: `${pushURL}`,
      method: "GET",
    });

    // GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
